/** @file Index of one channel inside Sample.values (the allocation-free form of channelOffsets). */
import { POSE_LAYOUT as L } from '../../contracts/pose';
import type { SkeletonData } from '../../skeletonData';

/** Entity block of a channel inside the Sample layout. */
export type ChannelBlock = 'bone' | 'slot' | 'ik';

/** Index in Sample.values / Sample.mask of channel `offset` (a POSE_LAYOUT offset) of `entity` in `block`. */
export function sampleIndex(data: SkeletonData, block: ChannelBlock, entity: number, offset: number): number {
  if (block === 'bone') return entity * L.LOCAL_STRIDE + offset;
  const slotStart = data.bones.length * L.LOCAL_STRIDE;
  if (block === 'slot') return slotStart + entity * L.SLOT_STRIDE + offset;
  return slotStart + data.slots.length * L.SLOT_STRIDE + entity * L.IK_STRIDE + offset;
}
